<template>
  <div v-if="loaded" class="mx-auto p-1 sm:px-4 sm:pt-20 sm:w-11/12 md:w-3/4 lg:w-1/2 xl:w-1/2">
    <debug-bar>
      <b-button @click="populateForm" variant="danger" size="sm" square>Popular</b-button>
      <b-form-checkbox v-model="showIds"><span class="text-danger">Visão</span></b-form-checkbox>
      <div @click="previousStep" class="cursor-pointer hover:text-danger font-bold"> {{"<"}} </div>
      <div> {{step}} </div>
      <div @click="nextStep" class="cursor-pointer hover:text-danger font-bold"> {{">"}} </div>
    </debug-bar>

    <!-- COVER/CAPA -->
    <b-card v-if="onCover">
      <due-diligence-cover :legal-entity="this.legalEntity"/>
      <hr/>
      <b-form-checkbox v-model="awareTruth">
        Declaro estar ciente de que todas as informações e documentos inseridos são verdadeiros, completos e precisos.
      </b-form-checkbox>
      <div class="flex justify-end">
        <b-button @click="step = 'form'" :disabled="!awareTruth" variant="primary">Continuar</b-button>
      </div>
      <template #footer>
        <form-footer/>
      </template>
    </b-card>

    <!-- PREENCHIMENTO -->
    <b-card v-if="onForm">
      <due-diligence-title class="pb-2"/>
      <hr/>
      <formula @mounted="formulaMounted" :debug="showIds" :form-definition="formDefinition" ref="formula" class="pb-2" v-model="data"/>
      <div class="flex justify-end">
        <b-button @click="submit" variant="primary" class="mr-2">Enviar</b-button>
        <b-button @click="step = 'cover'" variant="outline-secondary" class="float-right">Cancelar</b-button>
      </div>
      <template #footer>
        <form-footer/>
      </template>
    </b-card>

    <!-- CONFIRMAÇÃO -->
    <b-card v-if="onConfirm">
      <due-diligence-title class="pb-2"/>
      <formula @mounted="formulaMounted" :debug="showIds" view-only :form-definition="formDefinition" ref="formula" class="pb-2" v-model="data"/>
      <div class="mb-1">
        <b-form-checkbox v-model="confirmed" class="font-bold">Confirmo que todos os dados acimas estão corretos</b-form-checkbox>
      </div>
      <div class="flex justify-end">
        <b-button :disabled="!confirmed" @click="confirm" variant="primary" class="mr-2">Confirmar</b-button>
        <b-button @click="step = 'form'" variant="outline-secondary" class="float-right">Voltar</b-button>
      </div>
      <template #footer>
        <form-footer/>
      </template>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BButton,
  BLink,
  BContainer, BCol, BRow,
  BFormCheckbox
} from 'bootstrap-vue'
import Formula from '@/components/formula/Formula.vue'
import FormSubmissionService from '@/services/api/form/FormSubmissionService'
import DueDiligenceCover from './DueDiligenceCover.vue'

import DiligenceForm from '@/components/formula/example.json'
import FormFooter from '@/components/FormFooter.vue'

import {generateFakeData} from '@/components/formula/adapters/Formulate/compiler'
import DueDiligenceTitle from './DueDiligenceTitle.vue'

export default {
  props: {
    encrypt: {
      type: String,
      default: ''
    }
  },

  components: {
    BButton,
    BCard,
    BLink,
    BContainer, BCol, BRow,
    BFormCheckbox,
    Formula,
    FormFooter,
    DueDiligenceCover,
    DueDiligenceTitle,
  },

  data: () => ({
    loaded: false,
    data: {},
    service: null,
    step: 'cover',
    awareTruth: false,
    formDefinition: {},
    legalEntity: null,
    showIds: false,
    confirmed: false,
  }),

  beforeMount() {
    this.service = FormSubmissionService.build(this.$vs)
    this.formDefinition = DiligenceForm

    this.$vs.loading()
    this.service.getFormDefinition(this.encrypt).then(
      (response) => {
        this.legalEntity = this._.get(response, 'legal_entity')
        this.formDefinition = this._.get(response, 'definition')
        if (this.legalEntity && this.formDefinition) {
          this.loaded = true
        }
      },
      (error) => {
        this.notifyError(this.$vs, 'Não foi possível buscar os dados deste formulário.')
      }
    ).finally(
      () => this.$vs.loading.close()
    )
  },

  computed: {
    onCover() {
      return this.step == 'cover'
    },
    onForm() {
      return this.step == 'form'
    },
    onConfirm() {
      return this.step == 'confirm'
    },
    onSuccess() {
      return this.step == 'success'
    }
  },

  methods: {
    formulaMounted(event) {
      window.scrollTo(0,0)
    },
    nextStep() {
      const steps = ['cover', 'form', 'confirm']
      const next = steps.indexOf(this.step) + 1
      this.step = steps[next > (steps.length - 1) ? 0 : next]
    },
    previousStep() {
      const steps = ['cover', 'form', 'confirm']
      const previous = steps.indexOf(this.step) -1
      this.step = steps[previous < (steps.length - 1) ? 2 : previous]
    },
    populateForm() {
      const fake = generateFakeData(this.formDefinition)
      this.data = fake
    },
    async submit() {
      await this.$refs.formula.validateAsync()
      if (!this.$refs.formula.hasErrors()) {
        this.$vs.loading()
        this.service.validate(this.encrypt, this.data).then(
          response => {
            this.step = 'confirm'
            window.scrollTo(0,0)
          },
          error => {
            this.showErrors(this.$validator, error)
            //this.notifyWarning(this.$vs, this.$t('messages.error'), 5000)
            //this.notifyWarning(this.$vs, 'Você deve preencher todos os campos corretamente.', 5000)
          }
        ).finally(
          () => this.$vs.loading.close()
        )
      } else {
        this.$refs.formula.scrollToFirstInvalidField()
        this.notifyWarning(this.$vs, 'Você deve preencher este formulário por completo. Verifique os campos.', 3000)
      }
    },
    confirm() {
      this.$vs.loading()
      this.service.submit(this.encrypt, this.data).then(
        response => {
          this.step = 'success'
          this.notifySuccess(this.$vs, "O formulário foi enviado e está sendo processado pelo nosso sistema, você receberá um email com uma cópia das informações que inseriu.", 12000);
          setTimeout(() => {
            window.location.reload()
          }, 12000)
        },
        error => {
          this.notifyError(this.$vs,'Não foi possível processar este envio, tente novamente mais tarde.')
          this.step = 'form'
        }
      ).finally(
        () => this.$vs.loading.close()
      )
    }
  }
}
</script>

<style>

</style>
